module.exports = __webpack_public_path__ + "static/media/stretched_black.bd4f32e5.svg";